/**
 * Get runtime environment variable with fallback to build-time value
 * This allows the same build to work with different environment configurations
 * when deployed in containers
 *
 * @param key - The environment variable key
 * @returns The environment variable value
 */
export function getEnv(key) {
    // Try runtime config first (from window.ENV)
    if (typeof window !== 'undefined' && window.ENV?.[key]) {
        return window.ENV[key];
    }
    // Fallback to build-time config for development
    // @ts-expect-error - vite-specific
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        // @ts-expect-error - vite-specific
        return import.meta.env[key] || '';
    }
    return '';
}
/**
 * Create a typed environment getter for your specific environment variables
 *
 * @example
 * ```ts
 * interface MyEnv extends RuntimeEnv {
 *   VITE_API_URL: string;
 *   VITE_APP_NAME: string;
 * }
 *
 * const getMyEnv = createEnvGetter<MyEnv>();
 * const apiUrl = getMyEnv('VITE_API_URL');
 * ```
 */
export function createEnvGetter() {
    return (key) => getEnv(key);
}
